<script type="text/babel">
export default {
    data() {
        return {
            icon: 'fa-clipboard',
        }
    },

    methods: {
        copy() {
            const textToCopy = $(this.$el)
                .find('input[type=text]')
                .get(0)

            textToCopy.contentEditable = true
            textToCopy.readOnly = false

            textToCopy.select()
            textToCopy.setSelectionRange(0, 999999)

            if (document.execCommand('copy')) {
                this.icon = 'fa-check'
            }

            textToCopy.contentEditable = false
            textToCopy.readOnly = true
        },
    },

    render() {
        return this.$scopedSlots.default({
            copy: this.copy,
            icon: this.icon,
        })
    },
}
</script>
